// cityAddressServices.js
import apiService from "./apiServices";

// Search cities with optional state filtering and query
export const searchCities = async (query = '', stateCode = '', limit = 20, token) => {
  try {
    let endpoint = '/locale/search/cities';
    const params = new URLSearchParams();
    
    if (query) params.append('query', query);
    if (stateCode) params.append('stateCode', stateCode);
    if (limit) params.append('limit', limit);
    
    if (params.toString()) {
      endpoint += `?${params.toString()}`;
    }

    const response = await apiService(endpoint, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'City search service failed. Please try again.');
  }
};

// Get all states
export const getStates = async (token) => {
  try {
    const response = await apiService('/locale/search/states', 'GET', null, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'States service failed. Please try again.');
  }
};

// Get locale information (zip codes)
export const getLocaleInfo = async (token) => {
  try {
    const response = await apiService('/locale', 'GET', null, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Locale service failed. Please try again.');
  }
};

// Legacy function for backward compatibility
export const getCity = async (city, token) => {
  return searchCities(city, '', 20, token);
};

// Search zip codes
export const searchZipCodes = async (query = '', limit = 20, token) => {
  try {
    const params = new URLSearchParams();
    if (query) params.append('query', query);
    if (limit) params.append('limit', limit);

    const endpoint = `/locale/search/zip?${params.toString()}`;
    const response = await apiService(endpoint, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'Zip code search failed.';
  }
};
